module.exports = __webpack_public_path__ + "static/media/pin_dottor_grandine_highlighted.d0a892ea.png";